import * as React from "react";
import { connect } from "react-redux";

import { getHelpLinkRegionCode } from "features/regions/selectors";

const mapStateToProps = (state: any, { link }: { link: any }) => {
  const locale = getHelpLinkRegionCode(state);
  return {
    link: link(locale),
    to: link(locale)
  };
};

export default function withLocaleLink(Component: React.ComponentType<any>) {
  return connect(mapStateToProps)(Component);
}
